import * as React from 'react';

import { cn } from '../../services/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  as?: 'input' | 'textarea';
  theme?: 'new' | 'default';
}

const Input = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, InputProps>(
  ({ className, type, theme = 'default', as = 'input', ...props }, ref) => {
    const borders =
      theme === 'default'
        ? '!text-sh-sm border-[#CFD8DC] text-gray-700 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500'
        : '!text-sh-xxs border-[#607D8B] bg-white ring-offset-background placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-black ';
    return as === 'input' ? (
      <input
        type={type}
        className={cn('mt-1 block w-full rounded-lg border p-3', className, borders)}
        ref={ref as React.RefObject<HTMLInputElement>}
        {...props}
      />
    ) : (
      <textarea
        className={cn('mt-1 block w-full rounded-lg border p-3', className, borders)}
        ref={ref as React.RefObject<HTMLTextAreaElement>}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
